import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";
import { PageFrame } from "@/components/common";
import { adminService } from "@/services/adminService";
import { useAuthStore } from "@/store/authStore";
import { Permission } from "@/types";
import { StaffAccessEditor } from "./StaffAccessEditor";

export default function AdminStaffAccessRoute() {
  const { userId = "" } = useParams<{ userId: string }>();
  const { t } = useTranslation("adminUsers");
  const canReadUsers = useAuthStore((state) =>
    state.hasPermission(Permission.USERS_READ_ANY),
  );

  // No single-staff endpoint: the admin directory (role=ADMIN) carries the name.
  const { data: staffUsers } = useQuery({
    queryKey: ["admin", "users", { role: "ADMIN" }],
    queryFn: () => adminService.getUsers({ role: "ADMIN" }),
    enabled: canReadUsers,
  });
  const userName =
    staffUsers?.find((row) => row.user_id === userId)?.name ??
    t("staffAccess.userNameFallback");

  return (
    <PageFrame
      title={t("staffAccess.title", { name: userName })}
      description={t("staffAccess.subtitle")}
      icon={ShieldCheck}
      backLink={{ fallback: "/admin/users", children: t("detail.backToUsers") }}
    >
      <StaffAccessEditor userId={userId} />
    </PageFrame>
  );
}
